import {
  SET_PROMOS_TRANSACTION_DETAILS,
  SET_PETTY_CASH_TRANSACTION_DETAILS,
  SET_TOURNAMENT_HOUSE_TRANSACTION_DETAILS,
  ADD_PROMOS_TRANSACTION_DETAIL,
  ADD_PETTY_CASH_TRANSACTION_DETAIL,
  ADD_TOURNAMENT_HOUSE_TRANSACTION_DETAIL,
  UPDATE_PROMOS_TRANSACTION_DETAIL,
  UPDATE_PETTY_CASH_TRANSACTION_DETAIL,
  UPDATE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL,
  DELETE_PROMOS_TRANSACTION_DETAIL,
  DELETE_PETTY_CASH_TRANSACTION_DETAIL,
  DELETE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL,
} from '../actions/transactionDetails';

const initialState = {
  promosTransactionDetails: [
    "High Low In-Hand Bonus",
    "Morning High Hand", 
    "Weekend High Hand",
    "High Hand",
    "High Hand Quads",
    "Four Flush",
    "High Hand Minor",
    "In-Hand Bonus",
  ],
  pettyCashTransactionDetails: [
    "High Hand",
    "High Hand Quads",
    "Four Flush",
    "High Hand Minor",
    "High Low In-Hand Bonus",
    "Morning High Hand", 
    "Weekend High Hand",
    "In-Hand Bonus",
  ],
  tournamentHouseTransactionDetails: [
    "Tournament House Fees"
  ]
};

export default function transactionDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PROMOS_TRANSACTION_DETAILS:
      return {
        ...state,
        promosTransactionDetails: action.payload
      };

    case SET_PETTY_CASH_TRANSACTION_DETAILS:
      return {
        ...state,
        pettyCashTransactionDetails: action.payload
      };

    case SET_TOURNAMENT_HOUSE_TRANSACTION_DETAILS:
      return {
        ...state,
        tournamentHouseTransactionDetails: action.payload
      };

    case ADD_PROMOS_TRANSACTION_DETAIL:
      return {
        ...state,
        promosTransactionDetails: [...state.promosTransactionDetails, action.payload]
      };

    case ADD_PETTY_CASH_TRANSACTION_DETAIL:
      return {
        ...state,
        pettyCashTransactionDetails: [...state.pettyCashTransactionDetails, action.payload]
      };

    case ADD_TOURNAMENT_HOUSE_TRANSACTION_DETAIL:
      return {
        ...state,
        tournamentHouseTransactionDetails: [...state.tournamentHouseTransactionDetails, action.payload]
      };

    case UPDATE_PROMOS_TRANSACTION_DETAIL:
      return {
        ...state,
        promosTransactionDetails: state.promosTransactionDetails.map((detail, index) =>
          index === action.payload.index ? action.payload.detail : detail
        )
      };

    case UPDATE_PETTY_CASH_TRANSACTION_DETAIL:
      return {
        ...state,
        pettyCashTransactionDetails: state.pettyCashTransactionDetails.map((detail, index) =>
          index === action.payload.index ? action.payload.detail : detail
        )
      };

    case UPDATE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL:
      return {
        ...state,
        tournamentHouseTransactionDetails: state.tournamentHouseTransactionDetails.map((detail, index) =>
          index === action.payload.index ? action.payload.detail : detail
        )
      };

    case DELETE_PROMOS_TRANSACTION_DETAIL:
      return {
        ...state,
        promosTransactionDetails: state.promosTransactionDetails.filter((_, index) => index !== action.payload)
      };

    case DELETE_PETTY_CASH_TRANSACTION_DETAIL:
      return {
        ...state,
        pettyCashTransactionDetails: state.pettyCashTransactionDetails.filter((_, index) => index !== action.payload)
      };

    case DELETE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL:
      return {
        ...state,
        tournamentHouseTransactionDetails: state.tournamentHouseTransactionDetails.filter((_, index) => index !== action.payload)
      };

    default:
      return state;
  }
}
